<template>
  <div class="userCenter">
    <job-header-simple
      header_title="个人中心"
      :left_arrow="top_left_arrow"
      :left_text="top_left_text"
    ></job-header-simple>
    <header>
      <div class="radius_cornor" :class="{ noBg: mobileDefaultAvatar }">
        <!-- 73x73 -->
        <!-- <van-image
          width="1.9467rem"
          height="1.9467rem"
          fit="cover"
          :src="srcheader"
          class="header"
        />-->
        <van-uploader
          v-model="userImage"
          :max-count="2"
          :deletable="false"
          :preview-full-image="false"
          :after-read="beforeReadImg"
        />
        <div class="info">
          <p class="name">{{ activeUserInfo.name }}</p>
          <p class="tel">{{ activeUserInfo.mobile }}</p>
          <p class="mode1" v-if="showFree">
            <img src="./assets/mode1_icon.png" alt="" /><span
              >自由职业者模式</span
            >
          </p>
          <p class="mode2" v-else>
            <img src="./assets/mode2_icon.png" alt="" /><span
              >个体工商户模式</span
            >
          </p>
        </div>
        <div class="change" @click="showMode = true" v-show="showBt">
          <img src="./assets/mode3_icon.png" alt="" />
          切换模式
        </div>
      </div>
    </header>
    <van-row class="modules">
      <van-col span="6" v-for="(item, index) in modules" :key="index">
        <a
          v-if="
            item.href &&
              (customerServiceObjClose == null || customerServiceObjClose == 1)
          "
          :href="item.href"
          class="item"
        >
          <van-image
            width="0.9067rem"
            height="0.9067rem"
            fit="contain"
            :src="item.icon"
          />
          <p>{{ item.text }}</p>
        </a>
        <router-link :to="item.path" class="item" v-else>
          <van-image
            width="0.9067rem"
            height="0.9067rem"
            fit="contain"
            :src="item.icon"
          />
          <p>{{ item.text }}</p>
        </router-link>
      </van-col>
    </van-row>
    <div class="btn_logout">
      <van-button type="default" size="large" @click="logout"
        >退出登录</van-button
      >
    </div>
    <van-popup v-model="showMode" closeable class="popup-main">
      <div class="pop-header">
        <img src="./assets/popheader_icon.png" alt="" /> <span>切换模式</span>
      </div>
      <div class="pop-choose">
        <div class="mode-free">
          <div
            :class="{ 'mode-free-check': true, 'mode-checked': freeChecked }"
            @click="freeMode"
          >
            <img src="./assets/mode1_icon.png" alt="" />
            <span>自由职业者模式</span>
            <img v-if="freeChecked" src="./assets/checked_icon.png" alt="" />
            <img v-else src="./assets/check_icon.png" alt="" />
          </div>
        </div>
        <div class="mode-individual">
          <div
            :class="{
              'mode-individual-check': true,
              'mode-checked': !freeChecked,
            }"
            @click="individualMode"
          >
            <img src="./assets/mode2_icon.png" alt="" />
            <span>个体工商户模式</span>
            <img v-if="!freeChecked" src="./assets/checked_icon.png" alt="" />
            <img v-else src="./assets/check_icon.png" alt="" />
          </div>
        </div>
        <div class="pop-sure" @click="selectedMode">
          确定
        </div>
      </div>
    </van-popup>
       <van-popup  :close-on-click-overlay="false"  overlay :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }" v-model="showCertification" round position="center" :style="{ width: '95%' }" >
        <div class="certification-box">
            <p class="certification-title">人脸识别认证</p>
            <div class="certification-text">
                <p>
                     根据《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》政策要求，为确认为您本人操作，我们需要进行人脸识别。
                </p>
                <ul>
                    <li>我们仅收集必要的特征信息用于本次验证。</li>
                    <li>信息将进行加密处理，并严格遵循隐私政策。</li>
                </ul>
            </div>
            <div class="certification-btn-box-btn"> 
                
                <van-button
                type="primary"
                class="certification-btn"
                 @click="certification"
                >同意并验证</van-button
                >
            </div>
              
        </div>
    </van-popup>
  </div>
</template>
<script>
import { Image, Row, Col, Button, NavBar, Uploader, Popup, Toast } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import { mapGetters,mapMutations } from "vuex";
import { getToken } from "@/utils/auth";
//const srcheader = require("@/assets/user2.png");
import {
  employeeGetActiveUserPartInfo,
  employeeSetHeadshot,
  updateLastEmployeeMode
} from "@/api/employee/request";
import { removePassLoginFlagCode } from "@/utils/auth";
import { uploadFile } from "@/api/admin/file";
import api from "@/api/list";
import { browserUA } from '@/utils/browserUA'
import { getIndividualHeaderKey } from "@/utils/auth";

export default {
  components: {
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    jobHeaderSimple,
    [Popup.name]: Popup,
  },
  computed: {
    ...mapGetters([
      "customerServiceObjClose",
      "customerServiceObjPhoneNumber",
      "mobileDefaultAvatar",
      "userInfo"
    ]),
  },
  data() {
    return {
     showCertification:false,
      activeUserInfo: {},
      top_left_arrow: false,
      top_left_text: "",
      userImage: [],
      showFree: true,
      showMode: false,
      freeChecked: true,
      showBt: false,
      modules: [
        {
          id: 0,
          icon: require("./assets/icon_baseInfo.png"),
          path: "/userInfo",
          text: "基本信息",
        },
        {
          id: 1,
          icon: require("./assets/icon_attend.png"),
          path: "/editResume",
          text: "接单意向",
        },
        {
          id: 3,
          icon: require("./assets/icon_cantract.png"),
          path: "/contractList",
          text: "我的协议",
        },
        {
          id: 4,
          icon: require("./assets/icon_task.png"),
          path: "/myTasksList",
          text: "我的任务",
        },
        {
          id: 5,
          icon: require("./assets/icon_unlocked.png"),
          path: "/EditPassword",
          text: "修改密码",
        },
        {
          id: 6,
          icon: require("./assets/icon_notice.png"),
          path: "/news",
          text: "帮助中心",
        },
        {
          id: 7,
          icon: require("./assets/icon_kefu.png"),
          href:
            "//grejob.kefu.easemob.com/webim/im.html?configId=aaab0cb4-4a17-478b-9ab7-e90e515fbb15",
          text: "咨询客服",
        },
      ],
    };
  },
  async created() {
     this.hasFaceVedio();
     this.$store.dispatch('getUserInfo')
    let userId = await  this.getActiveUserAllInfoInit();
    if(userId.toString() !== "5257" && userId.toString() !== ""){
        let obj = {
          id: 2,
          icon: require("./assets/icon_card.png"),
          path: "/card",
          text: "我的收款账号",
        };
        this.modules.splice(2,0,obj);
   }
    this.initActiveUserInfo();
    if (!(this.customerServiceObjClose == null ||this.customerServiceObjClose == 1)) {
      this.modules.pop();
    }
    api.getAccountIdntityType().then((res) => {
      if (res.data.status == "200") {
        if (res.data.data.identityType === 'DOUBLE_IDENTITY') {
          this.showBt = true;
          this.showFree = res.data.data.lastMode==1?true:false;
          this.freeChecked = this.showFree;
        }
      }
    });
    if (getIndividualHeaderKey()) {
      this.showFree = false;
      this.freeChecked = false;
    }
  },
  methods: {
        hasFaceVedio(){
        api.hasFaceVedio().then(res=>{
          if(res.status=="200" && res.data.toString()==='0'){
            this.showCertification = true
          }else{
            this.showCertification = false
          }
        })  
    },
    //去认证
    certification(){
         this.showCertification = false
        api.individualFace({},{ method: "post" }).then((res) => {
              if (res.status == '200') {
                let json = JSON.parse(res.data.data)
                if (json == null) {
                  Toast.fail(res.data.message)
                } else {
                  browserUA().then((browserType) => {
                    if (browserType == 'androidAPP') {
                      window.VpShopJs.bodyCheck(
                        JSON.stringify({ url: json.url })
                      )
                    } else {
                      location.href = json.url
                    }
                  })
                }
              } else {
                Toast.fail('发起认证失败')
              }
            })
    },
    getActiveUserAllInfoInit(){
      return new Promise((resolve, reject) => {
        if(this.userInfo&&this.userInfo.id){
             resolve(this.userInfo.id);
        }else{ 
            if (getToken()) { 
                api.getActiveUserAllInfo().then((res) => {
                    if (res.data.status == "200") {
                    let user = res.data.data;
                      this.$store.commit('SET_USER_INFO', user)
                    resolve(user.id);
                    }
                }).catch(error => {
                    reject(error);
                });
            } else{
                resolve("");
            }
        }
  
      })
    },
    beforeReadImg(fileObj) {
      if (this.userImage.length == 2) {
        this.userImage.shift();
      }
      uploadFile(
        "employee-headshot",
        //    this.base64toFile(this.userImage[0].content)
        fileObj.file
      ).then((res) => {
        if (res.data.status == "200") {
          employeeSetHeadshot({ url: res.data.data }).then((res) => {
            if (res.data.status != "200") {
              this.$toast(res.data.message);
            }
          });
        } else {
          this.$toast(res.data.message);
        }
      });
    },
    initActiveUserInfo() {
      employeeGetActiveUserPartInfo().then((res) => {
        if (res.data.status == "200") {
          this.activeUserInfo = res.data.data[0];
          if (
            res.data.data[0].headshot &&
            typeof res.data.data[0].headshot != "undefined"
          ) {
            this.userImage.push({
              url: process.env.VUE_APP_FILE_PATH + res.data.data[0].headshot,
            });
          } else {
            if (this.mobileDefaultAvatar) {
              this.userImage.push({ url: this.mobileDefaultAvatar });
            } else {
              this.userImage.push({ url: require("@/assets/img_default.png") });
            }
          }
        }
      });
    },
    logout() {
        this.$store.commit('SET_USER_INFO',{})
      if (this.$store.getters.browserUA == "MINI") {
//        api.MiniLogout({}, { method: "patch" }).then((res) => {
//          if (res.data.data) {
//            this.clearLoginInfo();
//          }
//        });
          this.clearLoginInfo();
      } else if (this.$store.getters.browserUA == "WX") {
        api.WxLogout({}, { method: "patch" }).then((res) => {
          if (res.data.data) {
            this.clearLoginInfo();
            setTimeout(function() {
              location.reload();
            }, 500);
          }
        });
      } else if (this.$store.getters.browserUA == "APP") {
        api.AppLogout({}, { method: "patch" }).then((res) => {
          if (res.data.data) {
            this.clearLoginInfo();
            setTimeout(function() {
              location.reload();
            }, 500);
          }
        });
      } else {
        this.clearLoginInfo();
        setTimeout(function() {
          location.reload();
        }, 500);
      }
    },
    clearLoginInfo() {
      //debugger
      this.$store.dispatch("FedLogOut").then(() => {
        removePassLoginFlagCode();
        this.$router.push({ path: "/login" });
      });
    },
    base64toFile(dataurl, filename = "headPportrait") {
      let arr = dataurl.split(",");

      let mime = arr[0].match(/:(.*?);/)[1];

      let suffix = mime.split("/")[1];

      let bstr = atob(arr[1]);

      let n = bstr.length;

      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    freeMode() {
      this.freeChecked = true;
    },
    individualMode() {
      this.freeChecked = false;
    },
    selectedMode() {
      this.showMode = false;
      if (this.showFree == this.freeChecked) {
        return;
      }
      this.showFree = this.freeChecked;
      api.updateLastEmployeeMode({ id: this.userInfo.id, typeStr:this.showFree?"COMMON_EMPLOYEE":"INDIVIDUAL_BUSINESSES"},{ method: "post" }).then((res) => {
        if (res.data.status == "200") {
          // index1.html要用来获取请求头individualHeader
          if (this.showFree) {
            document.cookie='individualHeader='+'false';
            window.location.href = `${document.location.origin}/index.html#/user`;
          } else {
            document.cookie='individualHeader='+'true';
            window.location.href = `${document.location.origin}/index1.html#/user`;
          }
        }
      });

    },
     ...mapMutations(['SET_USER_INFO'])
  },
};
</script>

<style lang="less" scoped>
.certification-box{
    font-size: 14px;
    color: #333;
    padding: 0 6px;
    .certification-title{
        font-weight: bold;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
    .certification-text{
        line-height: 22px;
        p{
            text-indent: 2em;
        }
        ul{
            li{
                position: relative;
                padding-left: 36px;
                margin: 2px 0;
                list-style: none !important;
                &::before {
                content: '•';
                position: absolute;
                left: 25px;
                top: 2px;
                color: #333;
                font-size: 16px;
                line-height: 22px;
                }
            }
        }
        
    }
    .certification-btn-box-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 30px;
    }
    .certification-cancel{
         width: 100px;
        border-color:  #666;
        color: #333;
        margin-right: 12px;
    }
    .certification-btn{
      width: 120px;
      background: #6c7ef3;
      border-color:  #6c7ef3;
      border-radius: 4px;  
    }
}
.userCenter {
  header {
    padding: 10px 12px;
    background: #8390eb;
    background: -webkit-linear-gradient(#8390eb, transparent);
    background: -o-linear-gradient(#8390eb, transparent);
    background: -moz-linear-gradient(#8390eb, transparent);
    background: linear-gradient(#8390eb, transparent);

    /deep/ .van-uploader {
      vertical-align: middle;
      .van-uploader__upload {
        position: relative;
        // background: url(../../assets/img_default.png) center center no-repeat #ebecf4;
        // background-size: 73px 73px;
        border-color: transparent;

        .van-uploader__upload-icon {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 16px;
          height: 17px;
          background: url(../../assets/icon_camera.png) center center no-repeat
            transparent;
          background-size: contain;

          &:before {
            content: "";
          }
        }
      }

      .van-uploader__preview + .van-uploader__upload {
        background: transparent;
        margin-left: -88px;
      }
    }
    .radius_cornor {
      padding: 16px;
      position: relative;
      background-image: url(../../assets/logo_bg.png);
      background-repeat: no-repeat;
      background-position: right 10px;
      background-color: #fff;
      background-size: 138px 132px;
      border-radius: 6px;
      &.noBg {
        background: #fff;
      }
      .info {
        display: inline-block;
        vertical-align: middle;
        margin-left: 16px;
        color: #333;
        p {
          padding: 0;
          margin: 0;
        }
        .name {
          line-height: 30px;
          font-size: 18px;
          font-weight: 600;
        }

        .tel {
          line-height: 26px;
          font-size: 12px;
        }
        .mode1 {
          font-size: 9px;
          color: #ff893b;
          margin-top: -4px;
          img {
            height: 28px;
            width: 28px;
            margin-left: -4px;
            margin-bottom: -10px;
            margin-right: -4px;
          }
        }
        .mode2 {
          font-size: 9px;
          color: #7182f3;
          margin-top: -4px;
          img {
            height: 28px;
            width: 28px;
            margin-left: -4px;
            margin-bottom: -10px;
            margin-right: -4px;
          }
        }
      }
      .change {
        display: inline-block;
        position: absolute;
        top: 16px;
        right: 16px;
        font-size: 9px;
        color: white;
        background-color: #7182f3;
        border-radius: 10px;
        padding: 2px 8px;
        img {
          height: 9px;
          width: 9px;
        }
      }
    }
  }
}
.popup-main {
  background-color: #7182f3;
  width: 290px;
  height: 380px;
  border-radius: 10px;
  .pop-header {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    font-weight: 600;
    height: 20%;
    img {
      width: 60px;
      height: 60px;
      margin-left: -10px;
      margin-right: -16px;
    }
  }
  .pop-choose {
    width: 100%;
    height: 80%;
    background: white;
    font-weight: 700;
    text-align: center;
    .mode-free {
      padding: 20px;
      .mode-free-check {
        display: flex;
        width: 250px;
        height: 87px;
        border-radius: 3px;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        img {
          height: 60px;
          width: 60px;
        }
      }
    }
    .mode-individual {
      padding: 0 20px;
      .mode-individual-check {
        display: flex;
        width: 250px;
        height: 87px;
        border-radius: 3px;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        img {
          height: 60px;
          width: 60px;
        }
      }
    }
    .pop-sure {
      width: 93px;
      height: 30px;
      background-color: #7182f3;
      border-radius: 15px;
      font-size: 12px;
      color: white;
      line-height: 30px;
      margin-top: 30px;
      display: inline-block;
    }
  }
}
.mode-checked {
  background-color: #f5f5f5;
}
.btn_logout {
  margin: 0.32rem;
  overflow: hidden;
  /deep/ .van-button {
    border: none;
  }
}

.modules {
  background: #fff;
  margin: 0 0.32rem;
  border-radius: 0.16rem;
  padding: 0.32rem;
  .item {
    display: block;
    padding: 0.24rem 0;
    text-align: center;
    p {
      color: #333;
      font-size: 0.2933rem;
      margin-top: 6px;
    }
  }
}
</style>
